import { LanguageEnum } from '@models/entities/languages'

export const createLanguageTranslationsRequestUrl = (languageKey: LanguageEnum) =>
  `https://${import.meta.env.VITE_APP_DOMAIN}/files/langs/${languageKey}.csv`
